import { createContext, useContext } from "react";
import type { PatientLookupState } from "@/hooks/usePatientLookup";

// =============================================================================
// PatientLookupContext
//
// Holds the result of the in-flight /api/patient/lookup so that every
// step of the wizard can read from the same lookup. The lookup step
// drives the input (MRN + DOB), and the pickup / drop-off / requester
// steps consume the saved-* arrays to surface "use a saved place /
// phone / requester" pickers.
// =============================================================================

const defaultState: PatientLookupState = {
  status: "idle",
  patient: null,
  retry: () => {},
};

const PatientLookupContext = createContext<PatientLookupState>(defaultState);

export const PatientLookupProvider = PatientLookupContext.Provider;

export function usePatientLookupState(): PatientLookupState {
  return useContext(PatientLookupContext);
}
